const getStyles = (theme) => ({
  mainContainer: {
    boxShadow: '0 4px 45px 0px rgba(0, 0, 0, 0.08)'
  }
});

export default getStyles;
